import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import PersonIcon from '@mui/icons-material/Person';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { useEmailHistoryFilters } from 'hooks/emailHistory/useEmailHistoryFilters';
import { useIsMobile } from 'hooks/useIsMobile';
import { EmailHistoryErrorBoundary } from 'components/emailHistory';
import {
  CampaignsTab,
  BulkEmailsTab,
  IndividualEmailsTab,
  ScheduledTab
} from './tabs';

/**
 * @component EmailHistoryPage
 * @description Main page for Email History & Scheduled Emails with tab navigation
 * @returns {JSX.Element}
 */
function EmailHistoryPage() {
  const { filters, navigateToTab } = useEmailHistoryFilters();
  const isMobile = useIsMobile();

  const handleTabChange = (event, newValue) => {
    navigateToTab(newValue);
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      {/* Tab Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs 
          value={filters.tab} 
          onChange={handleTabChange} 
          aria-label="email history tabs"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-scrollButtons': {
              '&.Mui-disabled': { opacity: 0.3 },
            },
          }}
        >
          <Tab 
            icon={<CampaignIcon />}
            iconPosition="start"
            label={isMobile ? undefined : "Campaigns"}
            value="campaigns"
            aria-label="Campaigns"
          />
          <Tab 
            icon={<ForwardToInboxIcon />}
            iconPosition="start"
            label={isMobile ? undefined : "Bulk Emails"}
            value="bulk-emails"
            aria-label="Bulk Emails"
          />
          <Tab 
            icon={<PersonIcon />}
            iconPosition="start"
            label={isMobile ? undefined : "Individual Emails"}
            value="individual"
            aria-label="Individual Emails"
          />
          <Tab 
            icon={<ScheduleIcon />}
            iconPosition="start"
            label={isMobile ? undefined : "Scheduled"}
            value="scheduled"
            aria-label="Scheduled"
          />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box>
        <EmailHistoryErrorBoundary key={filters.tab}>
          {filters.tab === 'campaigns' && <CampaignsTab />}
          {filters.tab === 'bulk-emails' && <BulkEmailsTab />}
          {filters.tab === 'individual' && <IndividualEmailsTab />}
          {filters.tab === 'scheduled' && <ScheduledTab />}
        </EmailHistoryErrorBoundary>
      </Box>
    </Box>
  );
}

export default EmailHistoryPage;

